export default {
    '1b-diagram2': {
        'diagram-task': 'Arrange the points to fit the pyramid structure, then press the Submit button',
        'fixed-answer': 'The system of documenting property injects life into assets and makes them generate capital',
        'element_2_1': 'Represents it as a document',
        'element_2_2': 'Allows it to be used as collateral for credit',
        'element_2_3': 'Connects it to the rest of the economy'
    }
}


// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1b/diagram2/i18n/en.js